/**
 * main.tsx — точка входа React приложения.
 * Импортирует Tailwind CSS и монтирует корневой компонент.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Монтируем приложение в div#root из index.html
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
